import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, HostListener } from '@angular/core';

import { Subscription } from 'rxjs';
import { UiStateService } from 'app/core/store/ui/state-service';
import { AuthStateService } from '../../../../auth/store/auth.state-service';
import { defaultUser, userListDisplayColumns, UserListItem, toUserListItem } from 'app/auth/model/User';
import { EditingStatus } from 'app/core/models/common-types';
import { AuthService } from 'app/auth/auth.service';
import { ConfirmationService } from 'primeng/api';
import { Client, ClientDropdownItem } from 'app/features/admin/clients/model/Client';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PrimeNgModule } from '@core/primeng.module';
import { EditUserComponent } from '../edit-user/edit-user.component';
import { ClientStateService } from '../../clients/store/client.state-service';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [CommonModule, PrimeNgModule, EditUserComponent],
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserListComponent implements OnInit, OnDestroy {
  // routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  userListDisplayColumns = userListDisplayColumns;
  dataSource: UserListItem[];
  isLoading$ = this.uiStateService.isLoading$;
  userListItems: UserListItem[];
  selectedUserListItem: UserListItem;
  // selectedRowIndex = '';
  loggedInUser: UserListItem;
  selectedClient: Client;
  clientDropdownItems: ClientDropdownItem[];
  tableHeight = '40rem';
  // AG_SPORTS_BET_CLIENT_ID = _SPORTS_BET_CLIENT_ID;

  private subscriptions = new Subscription();
  constructor(
    private changeDetector: ChangeDetectorRef,
    private uiStateService: UiStateService,
    private clientStateService: ClientStateService,
    private authService: AuthService,
    private authStateService: AuthStateService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    console.log('MS UserListComponent ngOnInit');
    this.subscriptions.add(
      this.authStateService.loggedInUser$.subscribe((loggedInUser) => {
        this.loggedInUser = loggedInUser;
      })
    );

    this.subscriptions.add(
      this.clientStateService.clientDropdownItems$.subscribe((clientDropdownItems) => {
        this.clientDropdownItems = clientDropdownItems;
        if (this.clientDropdownItems?.length > 0) {
          this.updateDataSource();
        }
      })
    );

    this.subscriptions.add(
      this.authStateService.userListItems$.subscribe((userListItems) => {
        this.userListItems = userListItems;
        if (userListItems) {
          console.log('MS userListItems = ', userListItems);
          this.updateDataSource();
        }
      })
    );
  }

  updateDataSource() {
    if (this.clientDropdownItems?.length > 0 && this.userListItems?.length > 0) {
      this.dataSource = this.userListItems.map((item) => {
        const clientDropdownItem = this.clientDropdownItems.find((client) => client.id === item.clientId);
        return {
          ...item,
          clientName: clientDropdownItem ? clientDropdownItem.name : '',
        };
      });
    }
    // this.dataSource = [...this.userListItems];
    this.setTableHeight();
    this.changeDetector.detectChanges();
  }

  onRowSelect(event) {
    // this.selectedRowIndex = row.id;
    console.log('MS onRowSelect event= ', event);
    console.log('MS onRowSelect selectedUserListItem= ', this.selectedUserListItem);
    this.onEditUser(this.selectedUserListItem);
  }

  onEditUser(userListItem: UserListItem) {
    // this.selectedRowIndex = client.id;
    console.log('MS onEditUser userListItem= ', userListItem);
    this.authStateService.setSelectedUserListItem(userListItem);
    this.clientStateService.setClientEditingStatus(EditingStatus.EDITING);
    this.router.navigate(['/admin/edit-user', EditingStatus.EDITING]);
  }
  onAddNewUser() {
    this.authStateService.setSelectedUserListItem(toUserListItem(defaultUser, ''));
    this.authStateService.setUserEditingStatus(EditingStatus.ADDING);
    this.router.navigate(['/admin/edit-user', EditingStatus.ADDING]);
  }

  onAddUserToFirebase(user: UserListItem) {
    // console.log('MS onEditUser rCUser= ', rCUser);

    this.authService.registerUser(
      {
        email: user.email,
        password: `${user.first}123`,
      },
      user
    );
  }
  onResetPassword(user: UserListItem) {
    this.authService.sendPasswordReset(user.email);
  }

  onDeleteUser(user: UserListItem) {
    console.log('MS onDeleteUser user= ', user);
    console.log('MS onDeleteUser selectedUserListItem= ', this.selectedUserListItem);
    if (this.loggedInUser.id === user.id) {
      this.confirmationService.confirm({
        message: 'You cannot remove the user you are logged in as!',
        header: 'Remove User Error',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'none',
        rejectVisible: false,
        acceptLabel: 'OK',
        rejectButtonStyleClass: 'p-button-text',
        accept: () => {
          // this.messageService.add({ severity: 'info', summary: 'OK', detail: 'You have accepted' });
        },
        // reject: () => {
        //     this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      });
    } else {
      this.confirmationService.confirm({
        header: 'Remove User',
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        message: 'You are removing a User from the database!<p><p>Do you want to continue?',
        rejectButtonStyleClass: 'p-button-text',
        accept: () => {
          // console.log('MS confirm user= ', user);
          this.authStateService.deleteUser(user.id);
        },
        // reject: () => {
        //     this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      });
    }
  }
  onDone() {
    this.router.navigate(['/admin']);
  }

  setTableHeight() {
    this.tableHeight = `${window.innerHeight - 160}px`;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setTableHeight();
  }
  ngOnDestroy() {
    console.log('MS UserListComponent ngOnDestroy');
    this.subscriptions.unsubscribe();
  }
}
